import React, { useContext, useEffect, useState } from 'react';
import BuzzContext from '../../contexts/buzz';
import { admiralTag } from '@buzzfeed/bf-utils';

function AdmiralTagScript() {
  const { buzz = {} } = useContext(BuzzContext);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      setIsLoaded(true);
      admiralTag.init({
        destination: buzz.destination_name
      });
    }
  }, [isLoaded]);

  return (
    <></>
  );
}

export default AdmiralTagScript;
